import React from 'react';
import { string, element, oneOfType, func } from 'prop-types';

import { Consumer } from '~components/FormWrapper';

function Field({ name, component: Component, ...props }) {
  return (
    <Consumer>
      {({
        handleFocus,
        handleBlur,
        handleChange,
        values,
        errors,
        submitCount,
        focusedInput,
        avoidErrorUntilSubmit,
        setFieldValue,
        setFieldError,
        setFieldsError
      }) => (
        <Component
          name={name}
          value={values?.[name]}
          onFocus={handleFocus}
          values={values}
          onBlur={handleBlur}
          onChangeFormik={handleChange}
          error={(avoidErrorUntilSubmit || submitCount > 0) && errors[name]}
          isFocused={focusedInput === name}
          setFieldValue={setFieldValue}
          setFieldError={setFieldError}
          setFieldsError={setFieldsError}
          {...props}
        />
      )}
    </Consumer>
  );
}

Field.propTypes = {
  component: oneOfType([element, func]),
  name: string
};

export default Field;
